import template from './help.html';
import './help.scss';

export const CheckoutHelpModule =
    angular.module('app.components.checkout.components.checkoutHelp', []).component('checkoutHelp', {
        template,
        bindings: {},
        controller: class CheckoutHelpCtrl {
            constructor($window) {
                'ngInject';

                angular.extend(this, {
                    $window
                });
            }

            $onDestroy() {
                angular.element('body').removeClass('show-intercom');
            }
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/checkout/components/help/help.js